<template>
  <div>
    <div class="chat-style">
      <!-- 去除左边技能组菜单栏 -->
      <!-- <group-list v-if="channelGroupVoList.length > 1"></group-list> -->
      <div class="chat-container" @click="hideOpeart">
        <div class="chat-title" :style="{backgroundColor: config.color}">
          <span v-if="config.importing === '1' && isCusServiceInput[groupId] && isCusServiceInput[groupId].content === 'INPUT'" class="text">
            {{$t('inputHere')}}
          </span>
          <span v-else class="text">{{ config.title }} </span>
          <a-icon v-if="groupStatus === '1'" @click="endChat" class="close" type="close" />
        </div>
        <chatBody ref="chatBody"></chatBody>
        <div class="chat-footer" @click.stop="operatFooter">
          <faceBox v-show="isShowFaceBox" @getFace="hideFaceBox"></faceBox>
          <edit ref="edit" @sendMessage="sendMessage"></edit>
          <a-button class="send-btn" size="small" type="primary" @click="sendMessage">{{$t('send')}}</a-button>
        </div>
      </div>
    </div>

    <satisfaction ref="satisfaction"></satisfaction>
    <leaveMessage ref="leaveMessage"></leaveMessage>
  </div>
</template>
<script>
  import faceBox from '../components/faceBox'
  import edit from '../components/edit'
  import satisfaction from '../components/satisfaction'
  import leaveMessage from '../components/leave-message'
  import chatBody from '../components/chat-body'
  import groupList from '../components/group-list'
  import coreLogic from '@/common/mixins/core-logic.js'
  import socket from '@/common/mixins/socket.js'
  import {mapState, mapGetters} from 'vuex'

  export default {
    mixins:[coreLogic, socket],
    provide () {
      return {
        showFaceBox: this.showFaceBox,
        openUploadFileModal: this.openUploadFileModal,
        show_satisfaction: this.show_satisfaction,
        init_socket: this.init_socket,
        doToLeaveMessage: this.doToLeaveMessage,
        showLeaveMessage: this.showLeaveMessage,
        sendMediaMessage: this.sendMediaMessage,
        previewTextMessage: this.previewTextMessage,
        setBaseServiceInfo: this.setBaseServiceInfo,
        selectedSkill: this.selectedSkill,
        readVisitorMsg: this.readVisitorMsg,
        transferLabor: this.transferLabor
      }
    },
    components: {
      edit,
      faceBox,
      chatBody,
      satisfaction,
      leaveMessage,
      groupList
    },
    data () {
      return {
        isShowFaceBox: false,
        uploadParams: {},
        imageUrl: ''
      }
    },
    computed: {
      ...mapState({
        accessDetail: 'accessDetail',
        skillGroupAll: 'skillGroupAll',
        queueTips: 'queueTips', // 排队提示
        queueStatus: 'queueStatus',
        config: 'config',
        channelGroupVoList: 'channelGroupVoList',
        isCusServiceInput: 'isCusServiceInput',
        visitorStatus: 'visitorStatus'
      }),
      ...mapGetters({
        groupId: 'groupId',
        groupStatus: 'groupStatus'
      })
    },
    methods: {
      hideFaceBox (item) {
        this.$refs.edit.insertText(item.code)
        this.isShowFaceBox = false
      },
      showFaceBox () {
        this.isShowFaceBox = !this.isShowFaceBox
      },
      hideOpeart () {
        this.isShowFaceBox = false
      },
      operatFooter () {

      },
      sendMessage () {
        console.log(this.$refs.edit.message, 'this.$refs.edit.message');
        this.chatValue = this.$refs.edit.message.trim();
        // this.sendMessage(this.chatValue)
        // if (!this.visitorStatus) {
          
        // }
        console.log(this.chatValue, 'chatValue');
        if (this.chatValue) {
          this.sendTextMessage(this.chatValue)
          this.$refs.edit.message = ''
        }
      },
      show_satisfaction () {
        this.$refs.satisfaction.getFeed()
      },
      // 满意度
      inviteEvaluation (msg) {
        if (msg.invite.serviceId === this.serviceId) {
          this.show_satisfaction()
        } else {
          this.channelGroupVoList.forEach((item) => {
            if (item.service) {
              if (msg.invite.serviceId === item.service.serviceId) {
                this.set_noticeEvaluate({
                  serviceId: item.service.serviceId,
                  content: {
                    groupId: item.groupId,
                    groupName: item.groupName
                  }
                })
              }
            }
          })
        }
      },
      doToLeaveMessage () {
        // open('leaveMessage.html')
        this.$router.push({
          path: '/leave-message',
          query: {
            isSource: 1
          }
        })
      },
      showLeaveMessage () {
        this.$refs.leaveMessage.show()
      },
      maskTip () {
        this.$message.warn(this.$t('createSession'))
      }
    },
    created () {
      let param = this.$route.query;
      this.$store.commit('setVisitorInfo', param)
    },
    mounted () {
      // 获得初始配置
      // this.getConfigInfo()
      this.getCannelInfo()
      // 初始化
      this.init()
      this.$i18n.locale = this.config.language ? this.config.language : 'zh'
    }
  }
</script>
<style scoped lang="less">
@import "../css/chat";
</style>
